var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgMediumVehicle = function SvgMediumVehicle(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 73,
    viewBox: "0 0 72 73",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_14814_1779)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46.6666 3.646C48.1773 3.646 49.4023 4.87105 49.4023 6.38171V7.946C49.5468 7.95081 49.6919 7.99166 49.8238 8.07278L51.2675 8.96118H52.9282C53.4031 8.96118 53.788 9.34618 53.7881 9.821C53.7879 10.2957 53.403 10.6808 52.9282 10.6808H50.78L49.4023 9.83171V21.5415C49.4023 22.5305 48.6027 23.3317 47.6148 23.3362V25.1406H47.6541C49.0786 25.1407 50.2336 26.2956 50.2336 27.7201V67.6469C50.2332 69.071 49.0783 70.2254 47.6541 70.2255H24.2336C22.8093 70.2255 21.6545 69.0711 21.6541 67.6469V27.7201C21.6541 26.2956 22.8091 25.1406 24.2336 25.1406H24.6631V23.3371H24.3961C23.4045 23.3369 22.6006 22.5332 22.6006 21.5415V9.83171L21.2229 10.6808H19.0747C18.5999 10.6808 18.215 10.2957 18.2148 9.821C18.2149 9.34618 18.5998 8.96118 19.0747 8.96118H20.7354L22.1791 8.07278C22.311 7.99166 22.4561 7.95081 22.6006 7.946V6.38171C22.6006 4.87105 23.8256 3.646 25.3363 3.646H46.6666Z",
    stroke: "#BDBDBD",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.667 4.50684C47.7028 4.50684 48.5429 5.34608 48.543 6.38184V21.542C48.543 22.0589 48.1234 22.4785 47.6064 22.4785H24.3965C23.8796 22.4785 23.4609 22.0589 23.4609 21.542V6.38184C23.461 5.34612 24.3002 4.50691 25.3359 4.50684H46.667Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 1.71953
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.6006 26.001C48.5803 26.001 49.3749 26.7947 49.375 27.7744V67.5918C49.375 68.5716 48.5804 69.3662 47.6006 69.3662H24.2891C23.3094 69.3661 22.5156 68.5715 22.5156 67.5918V27.7744C22.5157 26.7948 23.3095 26.0011 24.2891 26.001H47.6006Z",
    fill: "#959595",
    stroke: "black",
    strokeWidth: 1.71953
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.5398 13.4927H33.461C33.0403 13.4927 32.6992 13.8338 32.6992 14.2545V17.3018C32.6992 17.7225 33.0403 18.0636 33.461 18.0636H38.5398C38.9606 18.0636 39.3016 17.7225 39.3016 17.3018V14.2545C39.3016 13.8338 38.9606 13.4927 38.5398 13.4927Z",
    stroke: "black",
    strokeWidth: 0.953827
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.1865 23.4209H25.0938V25.7064H47.1865V23.4209Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.859766
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.8943 4.50635H25.933C25.1644 4.50635 24.6743 5.32695 25.0387 6.00367L25.7224 7.27337C25.8995 7.60239 26.243 7.80756 26.6167 7.80756H45.2106C45.5842 7.80756 45.9278 7.60239 46.1049 7.27337L46.7886 6.00368C47.153 5.32695 46.6629 4.50635 45.8943 4.50635Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.859766
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.9277 9.82142H51.0232L49.3726 8.80566",
    stroke: "black",
    strokeWidth: 1.71953,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.543 11.0916V20.3334C48.543 20.6139 48.3156 20.8413 48.0351 20.8413H47.2733C46.9928 20.8413 46.7654 20.6139 46.7654 20.3334V11.8035C46.7654 11.6628 46.8237 11.5285 46.9265 11.4324L47.6883 10.7205C48.0129 10.4172 48.543 10.6474 48.543 11.0916Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.859766
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.0742 9.82142H20.9788L22.6294 8.80566",
    stroke: "black",
    strokeWidth: 1.71953,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.459 11.0916V20.3334C23.459 20.6139 23.6864 20.8413 23.9669 20.8413H24.7287C25.0092 20.8413 25.2366 20.6139 25.2366 20.3334V11.8035C25.2366 11.6628 25.1782 11.5285 25.0754 11.4324L24.3136 10.7205C23.989 10.4172 23.459 10.6474 23.459 11.0916Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.859766
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.4102 26.7335L24.4102 68.7148C24.4102 69.0252 24.1075 69.2453 23.8122 69.1497L22.9391 68.8672C22.7505 68.8061 22.6227 68.6305 22.6227 68.4322L22.6227 26.7335C22.6227 26.4811 22.8274 26.2764 23.0799 26.2764H23.953C24.2055 26.2764 24.4102 26.4811 24.4102 26.7335Z",
    fill: "#CDCDCD",
    stroke: "black",
    strokeWidth: 0.914286
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.4336 26.7335V68.2157C49.4336 68.3931 49.331 68.5545 49.1703 68.6297L48.2972 69.0385C47.994 69.1804 47.6462 68.9592 47.6462 68.6245V26.7335C47.6462 26.4811 47.8509 26.2764 48.1033 26.2764H48.9765C49.2289 26.2764 49.4336 26.4811 49.4336 26.7335Z",
    fill: "#CDCDCD",
    stroke: "black",
    strokeWidth: 0.914286
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.3468 66.4727H24.7092C24.5272 66.4727 24.3625 66.5807 24.2899 66.7476L23.4399 68.7043C23.3087 69.0062 23.53 69.3436 23.8591 69.3436H36.0325H48.2037C48.5334 69.3436 48.7547 69.0051 48.6224 68.7031L47.7656 66.7464C47.6928 66.5801 47.5284 66.4727 47.3468 66.4727Z",
    fill: "#CDCDCD",
    stroke: "black",
    strokeWidth: 0.914286
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.3058 29.8657H24.7499C24.5477 29.8657 24.3695 29.7329 24.3118 29.5391L23.5149 26.8641C23.4276 26.571 23.6472 26.2765 23.953 26.2765H48.1127C48.4192 26.2765 48.6389 26.5722 48.5504 26.8656L47.7435 29.5406C47.6852 29.7336 47.5074 29.8657 47.3058 29.8657Z",
    fill: "#CDCDCD",
    stroke: "black",
    strokeWidth: 0.914286
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_14814_1779"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 72,
    height: 72,
    fill: "white",
    transform: "translate(0 0.506348)"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgMediumVehicle);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "medium-vehicle.d1a7ba0bd24770622f3d2bc48423238d.svg";